import React, { useState } from 'react';
import styled from 'styled-components';
import { TextButton, Dropdown, DropdownItem } from '@amzn/storm-ui-v3';
import { useTranslation } from 'react-i18next';
import { ActionDropdownProps, ActionType } from './types';
import { DeleteModal } from '@urc-ui/components/delete-modal';

const CancelButton = styled(TextButton)`
  margin-right: ${({ theme }) => theme.spacing.base};
`;
CancelButton.displayName = 'CancelButton';

const ActionDropdown = (props: ActionDropdownProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleChange = (value: string) => {
    if (value === ActionType.Run) {
      props.onRunReport();
    } else if (value === ActionType.Copy) {
      props.onCopyReport();
    } else if (value === ActionType.Delete) {
      toggleModal();
    }
  };

  const handleOnDelete = () => {
    toggleModal();
    props.onDeleteReport();
  };

  return (
    <>
      <Dropdown onChange={handleChange} onOverrideLabel={() => t('sspa_rcm_ad_reports_column_header_action', 'Action')}>
        <DropdownItem value={ActionType.Run} disabled={props.capabilities && !props.capabilities.canRun}>
          {t('sspa_rcm_ad_reports_actions_dropdown_run_report', 'Run report')}
        </DropdownItem>
        <DropdownItem value={ActionType.Copy} disabled={props.capabilities && !props.capabilities.canCopy}>
          {t('sspa_rcm_ad_reports_actions_dropdown_copy_report', 'Create copy')}
        </DropdownItem>
        <DropdownItem value={ActionType.Delete} disabled={props.capabilities && !props.capabilities.canDelete}>
          {t('sspa_rcm_ad_reports_actions_dropdown_delete', 'Delete')}
        </DropdownItem>
      </Dropdown>
      <DeleteModal onCloseModal={toggleModal} onDeleteReport={handleOnDelete} isModalOpen={isModalOpen} />
    </>
  );
};

export { ActionDropdown };
